import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiTestTimerTypes extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}